import { API_BASE_URL, APP_ROLE } from '@/config/env'
import { SOCKET_EVENTS } from '@/entities/order/socket/events'
import { joinCourierRoom } from '@/entities/order/socket/joins'
import { useCourierStore } from '@/entities/courier/model/useCourierStore'
import { useCourierOrdersStore } from '@/features/courier-orders/model/useCourierOrdersStore'
import { connectSocket, off, on } from '@/shared/socket/socketClient'
import { useAuthStore } from '@/stores/auth'

let joinedCourierId = null
const socketHandlers = []

function registerHandler(event, handler) {
  on(event, handler)
  socketHandlers.push({ event, handler })
}

function clearSocketHandlers() {
  for (const { event, handler } of socketHandlers) {
    off(event, handler)
  }
  socketHandlers.length = 0
}

async function syncOrderFromSocket(payload) {
  const ordersStore = useCourierOrdersStore()
  await ordersStore.fetchOrderList({ force: true })

  const orderId = payload?.order_id
  if (!orderId) {
    return
  }

  const selectedId = ordersStore.selectedOrderId
  if (selectedId && String(selectedId) === String(orderId)) {
    await ordersStore.loadSelectedOrder(orderId, { silent: true })
  }
}

async function handleOrderUnassigned(payload) {
  const orderId = payload?.order_id
  const ordersStore = useCourierOrdersStore()
  await ordersStore.handleOrderUnassigned(orderId)
}

export async function startCourierRealtime() {
  if (APP_ROLE !== 'courier' || !API_BASE_URL) {
    return
  }

  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    return
  }

  const courierStore = useCourierStore()
  const courierId = courierStore.courierId
  if (!courierId) {
    return
  }

  try {
    await connectSocket()
  } catch (error) {
    console.warn('[realtime] socket connect failed', error)
    return
  }

  if (joinedCourierId !== courierId) {
    joinCourierRoom(courierId)
    joinedCourierId = courierId
  }

  if (socketHandlers.length === 0) {
    registerHandler(SOCKET_EVENTS.courier.ORDER_ASSIGNED, syncOrderFromSocket)
    registerHandler(SOCKET_EVENTS.courier.ORDER_UNASSIGNED, handleOrderUnassigned)
    registerHandler(SOCKET_EVENTS.courier.ORDER_STATUS_CHANGED, syncOrderFromSocket)
  }
}

export function stopCourierRealtime() {
  clearSocketHandlers()
  joinedCourierId = null
}
